<!-- TEMPLATE -->
<template>
  <div class="card card-overflow" style="max-height: 400px">
    <div class="card-header">
      <h5 class="card-category">History</h5>
    </div>
    <div class="card-body card-flex card-text-flex">
      <v-timeline dark dense clipped>
        <v-slide-x-transition group>
          <v-timeline-item
            v-for="event in sortedItems"
            :key="event.timestamp"
            class="mb-1"
            :color="getColor(event)"
            small
          >
            <v-row justify="space-between">
              <v-col cols="7" class="white--text">
                <v-chip
                  v-if="event.ticket == 'open'"
                  :color="'orange'"
                  small
                  outlined
                  >Ticket is {{ event.ticket }} by {{ event.email }}
                </v-chip>
                <v-chip
                  v-else-if="event.ticket == 'verified'"
                  :color="'red'"
                  small
                  outlined
                  >Ticket is {{ event.ticket }} by {{ event.email }}</v-chip
                >
                <v-chip
                  v-else-if="event.ticket == 'reported'"
                  :color="'primary'"
                  small
                  outlined
                  >Ticket is {{ event.ticket }} by {{ event.email }}</v-chip
                >
                <v-chip
                  v-else-if="event.ticket == 'resolved'"
                  :color="'green'"
                  small
                  outlined
                >
                  Ticket is {{ event.ticket }} by {{ event.email }}</v-chip
                >
                <v-chip
                  v-else-if="event.ticket == 'created'"
                  :color="'grey'"
                  small
                  outlined
                  >Ticket is {{ event.ticket }} by {{ event.email }}</v-chip
                >
                <v-sheet
                  v-else
                  outlined
                  round
                  color="primary"
                  rounded
                  style="font-size: 13px"
                >
                  {{ event.email }}
                  <v-card
                    outlined
                    style="color: black; background: #272a3d"
                    width="100%"
                    elevation="0"
                    ><v-card-text style="font-size: 12px">
                      {{ event.message }}</v-card-text
                    ></v-card
                  ></v-sheet
                >
              </v-col>
              <v-col class="text-right white--text" cols="5">
                <v-chip small outlined>
                  {{ event.timestamp | toReadableDate }}</v-chip
                >
              </v-col>
            </v-row>
          </v-timeline-item>
        </v-slide-x-transition>
      </v-timeline>
    </div>
  </div>
</template>

<!-- SCRIPT -->
<script>
import VueJsonPretty from "vue-json-pretty";
export default {
  name: "TimelinePlugin",
  data: function () {
    return {
      info: [],
    };
  },
  created() {
    this.info = this.timeline.concat(this.comments);
  },
  methods: {
    getColor(item) {
      switch (item.ticket) {
        case "open":
          return "orange";
          break;
        case "verified":
          return "red";
          break;
        case "reported":
          return "primary";
          break;
        case "resolved":
          return "green";
          break;
        default:
          return "grey";
      }
    },
  },
  filters: {
    toReadableDate(value) {
      return new Date(value * 1000).toLocaleString();
    },
  },
  computed: {
    sortedItems: function () {
      return this.info.sort((a, b) => b.timestamp - a.timestamp);
    },
  },
  components: {
    VueJsonPretty,
  },
  props: ["timeline", "comments"],
};
</script>

<!-- Style -->
<style>
.card-overflow {
  overflow: hidden !important;
}

.card-flex {
  display: flex !important;
  flex-direction: column;
}

.card-text-flex {
  flex-grow: 1;
  overflow: auto;
}
</style>
